import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { useFeature } from '@optimizely/react-sdk'

import Maintenance from 'pages/maintenance'
import OAuthLogin from 'pages/oauth-login'
import OAuthMfaChallenge from 'pages/oauth-mfa-challenge'
import { a4Login } from 'utils/experiments/features'

import ForgotPassword from './pages/forgot-password'
import A4ForgotPassword from './pages/forgot-password/A4_index'
import Login from './pages/login'
import A4Login from './pages/login/A4_index'
import MfaChallenge from './pages/mfa-challenge'
import A4MfaChallenge from './pages/mfa-challenge/A4_index'
import PageAnalytics from './utils/analytics/PageAnalytics'
import SetPageTitle from './utils/SetPageTitle'

const MainRouter = () => {
  const [a4LoginIsEnabled, _, clientReady, didTimeout] = useFeature(a4Login, {
    autoUpdate: true,
  })

  if (!clientReady && !didTimeout) {
    return null
  }

  return (
    <BrowserRouter>
      <>
        <SetPageTitle />

        {/* Note: Track all authenticated and unauthenticated page views to GA */}
        <PageAnalytics />

        <Switch>
          {/* For pages don't require authentication or require no authentication */}
          <Route
            path="/forgot-password"
            component={a4LoginIsEnabled ? A4ForgotPassword : ForgotPassword}
            exact
          />
          <Route
            path="/mfa-challenge"
            component={a4LoginIsEnabled ? A4MfaChallenge : MfaChallenge}
            exact
          />
          <Route path="/oauth" component={OAuthLogin} exact />
          <Route
            path="/oauth/mfa-challenge"
            component={OAuthMfaChallenge}
            exact
          />
          <Route path="/maintenance" component={Maintenance} exact />

          <Route path="/*" component={a4LoginIsEnabled ? A4Login : Login} />
        </Switch>
      </>
    </BrowserRouter>
  )
}

// Note: This component binds top-level 'page' components to various URL paths
export default MainRouter
